import { useEffect, useRef } from "react";
import Script from "next/script";

const SurveyModal = () => {
  const surveyContainerRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById("surveyModal");
    if (modalEl) {
      const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
      modal.show();
    }

    const observer = new MutationObserver((mutations, obs) => {
      const surveyElement = document.getElementsByClassName("smcx-widget")[0];

      if (surveyElement && surveyContainerRef.current) {
        surveyContainerRef.current.appendChild(surveyElement);
        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Script
        async
        id="academy-survey"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function(t,e,s,n){var o,a,c;t.SMCX=t.SMCX||[],e.getElementById(n)||(o=e.getElementsByTagName(s),a=o[o.length-1],c=e.createElement(s),c.type="text/javascript",c.async=!0,c.id=n,c.src="https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdwJ2AI1HHG42fiNjs_2BxoF2DSFztHvwViU3BzcEVmTOQY.js",a.parentNode.insertBefore(c,a))})(window,document,"script","smcx-sdk");`,
        }}
      />
      <div className="survey-modal-wrapper">
        <button
          class="btn btn-primary hide"
          data-bs-toggle="modal"
          data-bs-target="#surveyModal"
        >
          Launch demo modal
        </button>

        <div
          className="modal fade"
          id="surveyModal"
          tabIndex="-1"
          aria-labelledby="surveyModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div
                className="modal-header bg-cloud py-3"
                style={{ borderBottom: "1px solid #DDE3EE" }}
              >
                <h5
                  className="modal-title fw-semi-bold"
                  id="surveyModalLabel"
                >
                  Survey
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body p-0">
                <div
                  id="survey-container"
                  ref={surveyContainerRef}
                  className=""
                />
              </div>
              <div
                className="modal-footer py-3"
                style={{ borderTop: "1px solid #DDE3EE" }}
              >
                <a
                  data-bs-dismiss="modal"
                  className="link-basic"
                >
                  Close
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SurveyModal;
